import { render, staticRenderFns } from "./game-softgamings.vue?vue&type=template&id=14647e1d"
import script from "./game-softgamings.vue?vue&type=script&lang=js"
export * from "./game-softgamings.vue?vue&type=script&lang=js"
import style0 from "./game-softgamings.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/game/game-softgamings.vue
// module id = z+sm
// module chunks = 0